import { jsx as _jsx } from "react/jsx-runtime";
import { MAX_UINT256, PERCENTAGE_FACTOR, WAD, } from "@gearbox-protocol/sdk/onchain";
import WithRawValue from "./WithRawValue";
const Percent = props => {
    const { value, raw, className, flipRawValue } = props;
    let v = BigInt(value);
    if (v > 10n ** 14n) {
        v = (PERCENTAGE_FACTOR * v) / WAD;
    }
    const s = BigInt(value) >= MAX_UINT256 ? "∞" : `${Number(v) / 100}%`;
    return (_jsx(WithRawValue, { raw: raw ? BigInt(raw).toString() : undefined, className: className, flipRawValue: flipRawValue, children: _jsx("span", { children: s }) }));
};
export default Percent;
